let checkNaN = (value) => {
    if ( value == 'Na,NaN' || value == 0 ) {
        return '0,00 AED'
    } else {
        return value + ' AED';
    }
}

export default checkNaN;